import { render, staticRenderFns } from "./SelectAllButton.vue?vue&type=template&id=2e6381ca&scoped=true&"
import script from "./SelectAllButton.vue?vue&type=script&lang=js&"
export * from "./SelectAllButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6381ca",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e6381ca')) {
      api.createRecord('2e6381ca', component.options)
    } else {
      api.reload('2e6381ca', component.options)
    }
    module.hot.accept("./SelectAllButton.vue?vue&type=template&id=2e6381ca&scoped=true&", function () {
      api.rerender('2e6381ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/SelectAllButton.vue"
export default component.exports